export default {
  "action": "操作",
  "all": "全部",
  "allAssetHoldings": "总持仓量",
  "apiSpotTradingVolume": "API 现货交易量",
  "apply": "申请",
  "assetHoldingCalcQualification": "要判断我有资格获得 2 张还是 3 张抽奖券，资产持仓量要求是如何计算的？",
  "assets": "资产",
  "assetSnapshotRecord": "资产快照期间，您资金账户、现货账户及合约账户（或统一交易账户和反向合约账户）中的所有资产将通过每小时快照记录。",
  "available": "可用",
  "avgCryptoAssetInSnapshotPeriod": "{x} 天快照期间，所有加密货币的日均资产持仓量将通过每日快照记录。",
  "avgDailyAndFinalHoldingsInfo": "日均持仓量将根据您的钱包余额每小时快照计算得出。最终平均持仓量为您每日钱包余额的平均值。",
  "avgDailyHoldingsSnapshotPeriod": "{x} 天快照期间，以下账户的日均持仓量将通过每小时快照记录。",
  "avgPledgeAmountBetweenTimeRangeUtc": "{time1} – {time2} (UTC) 期间，日均持仓量至少达到 {minPledgeAmount} {currency}",
  "balance": "可用余额",
  "botValidateErrCode101": "最小价格太低",
  "botValidateErrCode102": "最小价格太高",
  "botValidateErrCode103": "最大价格太低",
  "botValidateErrCode104": "最大价格太高",
  "botValidateErrCode105": "网格数太少",
  "botValidateErrCode106": "网格数太多",
  "botValidateErrCode107": "投资额太低，未满足投资要求。",
  "botValidateErrCode108": "投资额太高，大于合约投资上限。",
  "botValidateErrCode109": "止盈价太低",
  "botValidateErrCode110": "止盈价太高",
  "botValidateErrCode111": "止损价太低",
  "botValidateErrCode112": "止损价太高",
  "botValidateErrCode113": "入场价太低",
  "botValidateErrCode114": "入场价太高",
  "buyDepositAdditionalAmount": "您需要追加买入/充值 <b>{additional_amount} {currency}</b>，才符合申购参与资格。所显示的MNT仅是您主账户中当前所持有的资产（资金账户， 现货账户与衍生品账户/ 统一交易账户与反向衍生品账户）， 不包含子账户中的资产与质押在Bybit储蓄中的资产。 具体的快照逻辑请参考下面的详细说明。",
  "buyDepositAdditionalAmountBeforeTimeUtc": "您需要在 {time} (UTC) 前追加买入/充值 <b>{additional_amount} MNT</b>。",
  "buyDepositAdditionalCurrencyForSubscription": "您需要追加买入/充值更多 {currency}（<a href=\"{url}\" target=\"_blank\">看看还需要多少</a>），才符合申购参与资格。",
  "buyDepositForLotteryTip": "您需要追加买入/充值更多 {currency}（<a href=\"{url}\" target=\"_blank\">看看还需要多少</a>），才符合抽奖参与资格。",
  "buyMore": "再买一笔",
  "buyMoreForHigherAllocation": "追加买入 {currency}，获得更高项目代币分配额度。",
  "calendar": "日历",
  "cancel": "取消",
  "cancelAll": "撤销全部",
  "cancelBak": "取消",
  "cancelOrder": "撤单",
  "checkSnapshotResult": "查看快照结果",
  "chooseOne": "（二选一）",
  "clickToJoinSale": "跟我一起参与 Bybit 上的 {token} Launchpad 代币发售！敬请点击此处：",
  "close": "关闭",
  "commitSubscriptionReminder": "恭喜！ 您符合认购资格。 继续持有您的资产直到快照期结束，然后在认购期间内返回此页面，以投入您的MNT代币。",
  "commitTokenSale": "投入 MNT 或 USDT，参与 {token} Launchpad 代币发售！",
  "confirm": "确认",
  "contract_account": "合约账户",
  "copyFailed": "复制失败",
  "copySuccessFully": "复制成功",
  "createErrorCode400": "用户发送的数据包含非法参数。有关更多信息，请查看错误消息和错误详情。",
  "createErrorCode401": "余额不足。",
  "createErrorCode402": "用户创建的机器人数量已达上限。",
  "createErrorCode403": "服务禁用",
  "createErrorCode404": "所请求资源未找到。",
  "createErrorCode407": "该用户类型不支持创建机器人子账户。",
  "createErrorCode408": "选择了重复定投标的",
  "createErrorCode409": "最大投资额无效",
  "createErrorCode410": "最大投资额无效",
  "createErrorCode411": "机器人已被关闭",
  "createErrorCode412": "统一保证金账户升级中",
  "createErrorCode500": "服务器内部错误",
  "createErrorCode501": "内部处理超时",
  "createErrorCode503": "当前定投机器人无法关闭，可能正在进行定投买入。",
  "currency": "币种",
  "currentOperationFailed": "操作失败，请重试。",
  "deposit": "充值",
  "depositAdditionalUsdtBeforeTimeUtc": "您需要在 {time} (UTC) 前追加充值<b> {additional_amount} USDT</b>。",
  "depositLotteryInfoUpdate": "如果您已按建议追加充值 {currency}，且未提币或兑换为其他代币，则符合抽奖参与资格，无需再次充值。您的最终日均持仓量将于 {time} 3:30 (UTC) 更新。",
  "derivativesAccount": "合约账户",
  "derivativesTrading": "衍生品交易",
  "detail": "详情",
  "details": "详情",
  "dialog_confirm_btn": "好的",
  "direction": "方向",
  "earnLotteryTicketsInfo": "根据您报名参与抽奖后的 VIP 等级、现货交易量和日均持仓量，您将获得 <b>{tickets} 张抽奖券</b>。",
  "earnLotteryTicketsInfoNew": "根据您报名参与抽奖后的 VIP 等级、现货交易量和日均持仓量，您将获得 {tickets} 张抽奖券。",
  "earnMaxVipLotteryTicketsInfo": "根据您报名参与抽奖后的 VIP 等级、现货交易量和日均持仓量，您将获得 <b>{tickets} 张抽奖券</b><b1>（额外抽奖券数量上限）</b1>。",
  "eeaCustomerParticipationProhibited": "本活动不面向来自以下国家/地区的用户开放：奥地利、比利时、保加利亚、克罗地亚、塞浦路斯、捷克共和国、丹麦、爱沙尼亚、芬兰、法国、德国、希腊、匈牙利、爱尔兰、意大利、拉脱维亚、立陶宛、卢森堡、马耳他、荷兰、波兰、葡萄牙、罗马尼亚、斯洛伐克、斯洛文尼亚、西班牙、瑞典、冰岛、列支敦士登和挪威（“欧洲经济区”）。所有欧洲经济区的用户均不符合参与资格。\n",
  "eligibilityLaunchpadEventNotice": "要参与 Launchpad 活动，请在您的 Bybit 账户中买入或充值所需金额的 MNT 或 USDT，并在快照期结束前一直持有资产，然后在申购期质押 MNT 或 USDT 代币。",
  "eligibleForLaunchpad": "<p>参与者必须完成 1 级个人身份认证或企业认证，方有资格参与 Launchpad 活动。请注意，来自服务受<a href=\"{link1}\" target=\"_blank\">限制国家/地区</a>的用户无法参与 Launchpad 项目。<p>\n\n<p>身份认证必须在申购期开始前完成。请点击<a href=\"{link2}\" target=\"_blank\">此处</a>完成认证。<p>",
  "end": "结束时间",
  "ended": "已结束",
  "ended1": "已结束",
  "eventParticipationEligibility": "很抱歉，您不能参与本次活动。更多相关信息，请参阅条款与条件。",
  "example": "示例",
  "exampleBak": "示例：",
  "fiat": "法币",
  "filter": "筛选",
  "finalSnapshotCalculationNotification": "正在计算您的最终快照持仓量。您可于 {time} (UTC) 查看自己是否符合资格。",
  "finalSnapshotCalculationNotificationNew": "正在计算您的最终快照持仓量。请于 {time} (UTC) 投入资金完成申购。",
  "finalTokenAllocation": "<p>在申购期，您需要访问 <a href=\"{link}\" target=\"_blank\">Bybit Launchpad</a> 并点击“立即投入”，为新项目投入一定数量的 MNT。<p>\n\n<p>最终代币分配数量 = (个人投入的 MNT 数量 / 所有参与者投入的 MNT 总量) * 分配到项目的新代币总量<p>\n\n<p>我们来举例说明：<p>\n\n<p>Bob 投入的 MNT 数量：1,000 MNT<p>\n<p>所有参与者投入的 MNT 总量：1,000,000 MNT<p>\n<p>项目分配的新代币（假设为“β”）总量：3,000,000 β<p>\n\n<p>在这种情况下，Bob 的最终分配数量为 3,000 β，计算方式如下：<p>\n<p>(1,000 MNT / 1,000,000 MNT) * 3,000,000 β<p>",
  "finish": "确认",
  "from": "开始时间",
  "fundingAccount": "资金账户",
  "fundingAccountSnapshotInfo": "<p>- 您的 MNT 或 USDT 余额，以及质押在 Launchpool 和活期储蓄中的 MNT 或 USDT，将自动计入您资金账户的资产快照。质押在定期储蓄、双币投资以及跟单交易 Pro 等其他产品中的资产不计算在内。</p>",
  "fundingAndDerivativesAc": "<p>资产快照期间，资金账户、现货账户及合约账户（或统一交易账户和反向合约账户）中的 MNT 或 USDT 余额将会计算在内。<p>\n\n<p>- 对于资金账户，在活期储蓄和 Launchpool 中质押的 MNT 将自动计入资金账户的资产快照。质押在其他 Bybit 理财产品（如流动性挖矿）和结构化产品（如双币投资）中的 MNT 不计入快照。<p>\n\n<p>- 对于合约账户，钱包余额将会计算在内。请注意，钱包余额可能会受到已结盈亏的影响。<p>",
  "gainEarlyAccessToTokens": "率先获得 Bybit 明星项目的代币",
  "getLotteryTicketNotice": "投入 {minPledgeAmount} {currency} 参与抽奖，即可获得 1 张抽奖券，点击了解如何<a href=\"{url}\" target=\"_blank\">获得更多抽奖券</a>。",
  "getMoreTickets": "获得更多抽奖券",
  "getVerified": "去认证",
  "global_setting_quick_order_desc": "<p>1. 市价单（快捷下单）</p>\n<p>2. 请注意，填写的购买数量可能与输入的订单数量略有不同。</p>",
  "global_setting_quick_order_label": "快捷下单",
  "global_setting_title": "自定义设置（适用于现货）",
  "gridDcaBot": "网格机器人、定投机器人",
  "hint": "提示",
  "holdAvgMinPledgeBetweenTimeUtc": "{time1} – {time2} (UTC) 期间，日均持仓量至少达到 {minPledgeAmount} {currency}",
  "holdingsCalculationForMntOrUsdt": "如何计算参与 MNT 申购或 USDT 抽奖的持仓量？",
  "initialTokenSale": "{token} 首次代币发售",
  "innovateQuota": "可用额度",
  "inverseDerivativesAccount": "反向合约账户",
  "joinLaunchpadPurchaseLink": "与我一起参与 {token} Launchpad，玩转发行价买币！点击此处：",
  "joinLaunchpadPurchaseTip": "与我一起参与 {token} Launchpad，玩转发行价买币！",
  "joinLotteryBeforeTimeUtc": "请在 {time} (UTC) 前参与抽奖。",
  "joinLotteryWinAllocation": "投入 {currency}，参与抽奖，即有机会获得 {token} 分配",
  "joinLotteryWithAvgBalance": "日均持仓量至少达到 {minPledgeAmount} {currency}，即可参与抽奖，有机会获得 {token} 分配。",
  "joinSubscriptionBeforeTimeUtc": "请在 {time} (UTC) 前参与申购。",
  "joinTokenSale": "加入 {token} Launchpad！",
  "kline": "K线",
  "l_version_tip": "当前版本不支持Launchpad活动，请更新至最新版！",
  "launchpad": "Launchpad",
  "launchPad": "Launchpad",
  "leverage": "杠杆倍数",
  "leverage_off_trade_tip": "请开启杠杆，然后参与杠杆交易。",
  "leverageCloseErrInfo": "操作失败！您需要还清全部欠款后，才能关闭杠杆交易。",
  "leverageCloseTips": "操作失败！您的账户存在进行中的杠杆订单。",
  "leveragedTokens": "杠杆代币",
  "leverageLoanTips": "操作失败！您的统一保证金账户的 IM 或 MM 占用率已超过预警值。",
  "leverageTryAgain": "系统异常，请您稍后重试！",
  "liquidationErrorInfo": "操作失败！账户已触发强制平仓。",
  "loading_text": "正在加载",
  "loan": "借款",
  "loan_spot_account": "现货账户",
  "login": "登录",
  "loginToCheck": "登录查看",
  "lotteryDrawDefinition": "什么是代币分配抽奖？",
  "lotteryEligibilityCongrats": "恭喜！您符合抽奖参与资格。",
  "lotteryEligibilityReminder": "恭喜！ 您符合认购资格。 继续持有您的资产直至快照期结束，然后在认购期间内返回此页面，以投入您的USDT代币。",
  "lotteryJoinErrorTip": "抱歉！您的日均持仓量未达到参与抽奖的最低资格要求，因此您不能参与抽奖。下次 Launchpad 请确保 {currency} 充值数额达到要求。",
  "lotteryTicketsAllocation": "<p>代币分配抽奖是指通过随机抽取中奖券来确定中奖者。通过抽奖，幸运参与者将赢得新代币的分配权。<p>\n\n<p>在每次 Launchpad 活动中，参与者最多可获得的抽奖券数量取决于在快照期间完成的任务数量。获得的抽奖券越多，赢得代币分配的几率越大。<p>",
  "lp_active_active": "进行中",
  "lp_active_before": "注册",
  "lp_active_end": "已结束",
  "lp_active_joined": "加入成功！",
  "lp_asset_statistics": "资产快照",
  "lp_asset_statistics_desc": "在 5 天周期内，您现货账户和合约账户的钱包余额（以美元计算）将通过每小时快照记录。在此期间，钱包余额越高，获得的 {currency} 币就越多！",
  "lp_balance": "钱包余额",
  "lp_balance_explain": "在 5 天计算期内，您的平均每日钱包余额（以美元计算）将通过每小时快照进行记录并在 UTC 时间次日凌晨 3 点更新。<br>假设在 9 月 24 日，Bob 注册了 Bybit，并在 UTC 时间晚上 9 点存入价值 100 美元的存款。 他的钱包余额每小时快照将在 UTC 时间晚上 9 点记录为 100 美元，UTC 时间晚上 10 点记录为 200 美元，UTC 时间晚上 11 点记录为 300 美元。 因此，他在 9 月 24 日的平均每日钱包余额为 25 美元*。 在 UTC 时间 9 月 25 日凌晨 3 点，Bob 将看到他在 9 月 24 日的平均每日钱包余额更新为 25 美元。<br>*[($100 + $200 + $300)/24] = $25 <br>您在这 5 天计算期内的平均钱包总余额越高，可获得的 BIT 就越多！",
  "lp_balance_explain_close": "收起",
  "lp_balance_explain_open": "查看更多",
  "lp_btn_join": "立即加入",
  "lp_btn_kyc": "立即认证",
  "lp_issue_num": "分配总量",
  "lp_item_desc": "BIT 是 BitDAO 的原生代币",
  "lp_join": "参与报名",
  "lp_join_desc": "您必须在报名阶段点击报名以参加活动。报名成功后，您将自动获得参与锦鲤抽奖和代币发放的资格，最高可免费赢取 3,500 枚 {currency}。请注意，在此期间之前，您无需进行任何注册操作。 您平均每日现货账户和合约账户的钱包余额快照将被自动记录。 请 <a href=\"https://www.bybit.com/user/accounts/auth/personal\">点击此处</a>立即完成 KYC L1 身份认证，以获得参加活动的资格。",
  "lp_link_bps": "白皮书",
  "lp_link_rule": "活动规则",
  "lp_link_website": "官网",
  "lp_no_kyc": "Launchpad 要求完成 1 级 KYC。",
  "lp_project_community": "社媒平台",
  "lp_project_desc": "项目简介",
  "lp_project_desc_content": "BitDAO 是全球最大的去中心化自治组织（DAO）之一，旨在打造开放式金融以及去中心化的代币经济。",
  "lp_project_highlight": "项目亮点",
  "lp_project_highlight_desc": "BitDAO 是全球最大的去中心化自治组织（DAO）之一，主要支持者包括 Peter Thiel、Founders Fund、Pantera、Dragonfly、Spartan、Bybit 等。\n\n<br>Bybit 已承诺向 BitDAO 金库提供常规捐赠。按 2021 年费率计算，每年将超过 10 亿美元。\n\n<br>BitDAO 寄希望于加密技术的成功，并将分配大量资源来支持其发展。\n\n<br>BitDAO 可通过代币兑换和共同开发开展项目合作。主要支持形式有：研发支持、流动性引导以及资金支持。",
  "lp_project_title": "BitDAO — 币力同心",
  "lp_table_label1": "发放总量",
  "lp_table_label2": "代币发放",
  "lp_table_label3": "锦鲤抽奖",
  "lp_table_label4": "个人上限（代币发放）",
  "lp_table_label5": "个人上限（锦鲤抽奖）",
  "lp_tdk_desc": "在 Bybit 平台探索最具前景的新兴加密货币项目，兼顾适应性框架、合法性和扩展潜力。",
  "lp_tdk_title": "Bybit Launchpad | 探索新兴项目",
  "lp_time": "时间",
  "lp_token_distribution": "代币发放",
  "lp_token_distribution_desc": "我们会先根据锦鲤抽奖结果计算您赢得的 {currency} 数量，再根据您 5 天内现货账户和合约账户的日均钱包余额，计算您赚取的 {currency} 数量。请注意：我们将 {currency} 发放至您的现货账户大约需要30分钟。",
  "lp10_introduce": "TAP FANTASY（TAP）：“P2E”奥多姆大陆",
  "lp10_introduce_desc2": "Tap Fantasy 为免费 MMORPG 区块链游戏，设置 200 多个角色配备不同 NFT 皮肤，以 P2E 模式运行。玩家可自由探索开放世界，建设自己的元宇宙！",
  "lp10_introduce_desc3": "<br>Tap Fantasy 最初以 TapTap Fantasy 在 Facebook Gaming 发布，并迅速成为平台最受欢迎的角色扮演冒险类游戏。游戏在不到六个月的时间吸引超过 150 万用户，日均活跃用户数量（DAU）接近 40 万。2021 年 9 月底，TapTap Fantasy 全球用户量已超过 2000 万。\n\n<br>第三方游戏开发者可通过 Tap Fantasy 的无代码地图编辑器创建和设计游戏模块。玩家还可以上传自己设计的 NFT 头像、壁纸、外形、皮肤等内容。买到 NFT 皮肤后，玩家可以进入 VIP 打宝区获得游戏代币和其他玩家设计的 NFT 皮肤。 \n\n<br>TAP 代币为 Tap Fantasy 的 DAO 治理代币，具备常规 DAO 治理功能。 ",
  "lp10_project_desc": "“P2E”奥多姆大陆",
  "lp3_introduce": "Genopets — 您的 NFT 精神动物",
  "lp3_introduce_desc2": "Genopets 是一款基于 Solana 的 NFT 游戏，完美融合“免费游戏”与“运动赚币”的理念。在游戏中探索 Genoverse 时，玩家可通过现实世界的运动赚取加密货币。",
  "lp3_introduce_desc3": "<br>Genopets 开创了一种全新游戏类别，即“运动赚币”。它融合了移动游戏中的免费游戏与区块链生态系统中“边玩边赚”的精华。\n\n<br>Genopets 将玩家在现实世界中的身体运动与其在 Genoverse 中的发展与价值创造联系起来。\n \n<br>目前，Genopets 筹集了 830 万美元的种子轮融资，由 Konvoy Ventures、Pantera Capital 以及加密货币、游戏和健身领域的著名天使投资人领投。",
  "lp3_project_desc": "Genopets — 您的 NFT 精神动物",
  "lp4_introduce": "Pintu — 印度尼西亚加密货币交易所",
  "lp4_introduce_desc2": "Pintu 成立于 2020 年 4 月，是印度尼西亚商品期货交易监管局（BAPPEBTI）监管的持牌加密货币经纪商。",
  "lp4_introduce_desc3": "<br>Pintu 聚焦首次投资加密货币的用户，已经在 A1 轮融资中筹集了 3500 万美元。\n \n<br>Pintu 得到了主流加密货币投资者的支持，包括 Pantera Capital、Coinbase Ventures、Intudo Ventures 等。\n \n<br>在成立一年半的时间里，Pintu 便吸引了超过 100 万活跃用户。",
  "lp4_project_desc": "印度尼西亚加密货币交易所",
  "lp5_introduce": "Symbiosis Finance (SIS) - 多链流动性赋能者",
  "lp5_introduce_desc2": "Symbiosis Finance (SIS) 是一种去中心化多链流动性协议，允许用户以低滑点在链间交换代币，同时继续成为资金的唯一所有者。",
  "lp5_introduce_desc3": "<br>Symbiosis Finance 为所有 Layer 2 解决方案和前景光明的 Layer 1 平台（如 Solana、Algorand 和 Near）聚合去中心化交易所的流动性。\n \n <br>Symbiosis Finance 提供无限的跨链流动性，它尽可能多地为所有链上的代币对提供服务，同时也为任意代币对之间的交换提供最优价格。 \n \n <br>Symbiosis Relayers 网络是一种无许可性点对点中继者网络，独立于区块链，内置加密货币经济激励机制。",
  "lp5_project_desc": "多链流动性赋能者",
  "lp6_daily_wallet_desc": "4 天资产快照期内，您资金账户、现货账户及合约账户（或统一保证金账户/统一交易账户和反向合约账户）中的日均持仓量将通过每小时资产快照进行记录。当天的日均持仓量将于次日 3:00 (UTC) 更新。 \n\n举例说明：假设 Bob 在 10 月 28 日注册了 Bybit 账户，并从 21:00 (UTC) 开始每小时为资金账户充值 100 MNT。Bob 的每小时余额快照记录如下：21:00 (UTC) 100 MNT，22:00 (UTC) 200 MNT，23:00 (UTC) 300 MNT。因此，10 月 28 日 Bob 资金账户中的 MNT 日均持仓量将达到 25 MNT。\n\n[(100 + 200 + 300) / 24] = 25 \n\n10 月 29 日 3:00 (UTC) 之后，Bob 会看到其 10 月 28 日的 MNT 日均持仓量（资金账户）更新为 25 MNT。",
  "lp6_daily_wallet_desc_v2": "在 {snapshot_days} 天快照期内，您资金账户、现货账户及合约账户（或统一交易账户和反向合约账户）中的日均持仓量将通过每小时资产快照进行记录。当天的日均持仓量将于次日 3:00 (UTC) 更新。\n\n假设 Bob 在 10 月 28 日注册了 Bybit 账户，并从 21:00 (UTC) 开始每小时为现货账户充值 100 MNT。Bob 的每小时余额快照记录如下：21:00 (UTC) 100 MNT，22:00 (UTC) 200 MNT，23:00 (UTC) 300 MNT。因此，10 月 28 日 Bob 现货账户中的 MNT 日均持仓量将为 25 MNT。\n\n[(100 + 200 + 300) / 24] = 25\n\n10 月 29 日 3:00 (UTC) 之后，Bob 会看到他 10 月 28 日的 MNT 日均持仓量（现货账户）更新为 25 MNT。",
  "lp6_introduce": "REAL — 3D 虚拟世界",
  "lp6_introduce_desc2": "Realy Metaverse（REAL）是一种 3D 虚拟世界。用户在其中可以交互、铸造和交易各种基于 NFT 的音乐、游戏、时尚产品和收藏品。",
  "lp6_introduce_desc3": "<br>Realy Metaverse 在以太坊网络中开发了 Bearache，即包含 1 万只独特小熊的系列收藏品。Bearache 不仅是虚拟宠物，也是会员专属俱乐部的入场券。\n \n <br>Realy Metaverse 打造的 NFT 拥有与之匹配的实体等价物。这些实体等价物植入了 NFC 芯片，可轻松验证其真实性。\n \n <br>Realy Metaverse 是在 Solana 中构建的第一个大型街头文化元宇宙，提出了“边生活边赚钱”的新理念。\n \n <br>Realy Metaverse 获得了 Alameda Research、Multicoin、三箭资本（Three Arrows Capital）和 District0x 等众多机构的支持。",
  "lp6_join_step1_desc": "在<b>{date}</b>期间，您的现货账户、理财 账户和合约账户中的 BIT 日均余额必须达到或高于 {amount}，相关数值将向下取整。",
  "lp6_join_step2_desc": "您可以在现货账户中为新项目提交一定数量的 BIT。 为此，您必须在订阅期内点击“立即认购”按钮，且您提交的 BIT 数量将被锁定，在最终分配 {currency} 前无法进行划转、提现或交易。 请注意，如果您在 Launchpool 中质押了 BIT，请前往“订单&交易” - “理财账户” - “Launchpool”，先取消质押您的 BIT，然后手动将其转移到现货账户。 如果您在理财账户或合约账户下持有 BIT，请手动将其转入您的现货账户。",
  "lp6_project_desc": "3D 虚拟世界",
  "lp7_introduce": "izumi Finance（IZI）— 多链流动性即服务供应商",
  "lp7_introduce_desc2": "izumi Finance 是基于 Uniswap V3 的多链流动性即服务（LaaS）供应商，其原生代币为 IZI。",
  "lp7_introduce_desc3": "<br>Izumi Finance 是首个允许在 Uniswap V3 中开展可编程流动性挖矿的多链挖矿协议。\n<br>它还将 Uniswap V3 的自动做市商（AMM）功能扩展至其他 Layer 2 链。\n<br>该协议旨在减少代币跨链转移所需的时间和相关成本。\n代币通过 Izumi 跨链转移只需不到 1 分钟，矿工费也不足 1 美元。\n<br>Izumi Finance 获得了 IOSG Ventures、Everest Ventures Group（EVG）、Cadenza Capital Management、分布式资本、金沙江创业投资、CyberX、HashKey、Nansen等众多机构的投资。",
  "lp7_project_desc": "多链流动性即服务供应商",
  "lp8_introduce": "Kasta（KASTA）——免费、高效的加密货币支付方式",
  "lp8_introduce_desc2": "Kasta 加密货币支付平台提供跨境点对点的加密货币实时交易。此外，同种加密货币或用户之间的支付交易不收取任何费用。",
  "lp8_introduce_desc3": "<br>即使不了解加密货币的用户也能通过 Kasta 轻松无忧地存储、转账和接收加密货币。用户仅需添加电话号码、邮箱地址，或扫描二维码即可通过 Kasta 交易加密货币。\n \n<br>无论付款方使用何种货币，通过 Kasta 兑换引擎，用户能任意选择希望接收到的加密货币或法币币种。Kasta 正在开发便捷的法币线上和线下兑换服务，实现银行与 Kasta 之间的转账，以及直接向 Kasta 以外的借记卡付款。\n \n<br>Kasta 同时还在研发一种独特的支付解决方案，用户无需立即付款即可从网上商店购买商品。用户通过 Kasta 平台选择延迟支付的具体时间和方式。\n \n<br>用户持有 Kasta 生态系统的原生代币 KASTA，即可享受更低的交易费用和返现等诸多权益。",
  "lp8_project_desc": "免费、高效的加密货币支付方式",
  "lp9_introduce": "MONSTER GALAXY P2E（GGM）：传奇系列游戏全新升级边玩边赚模式",
  "lp9_introduce_desc2": "《MONSTER GALAXY》边玩边赚游戏是一款传奇手游系列的区块链版本。在游戏中，玩家拥有 NFT 形式的怪兽宠物，并可赚取及交易游戏内代币 GGM 来购买游戏内物品。",
  "lp9_introduce_desc3": "<br>《MONSTER GALAXY》游戏自 2011 年首次上线以来，已收获超过 2500 万用户。游戏的最新版本融入了 NFT 和边玩边赚元素。\n \n <br>在《MONSTER GALAXY》边玩边赚游戏中，玩家驯服的每个 MOGA 怪物都代表一个独一无二的 NFT，可通过游戏内的虚拟商店或其他主要 NFT 市场进行交易。MOGA 的稀缺度共分为七（7）个等级。 \n \n <br>玩家还可通过与怪兽或其他玩家搏斗对战，赚取名为“Galaxy Gem”或“GGM”的游戏内代币。游戏中的 GGM 可用于为 MOGA 购买能量和附加血槽，并用来获得游戏特权和质押奖励。GGM 和所有游戏内物品均可通过支持的开放市场进行交易。\n \n <br>《MONSTER GALAXY》边玩边赚游戏将在 2022 年 2 月发布测试版本，并于 2022 年 3 月正式上线。",
  "lp9_project_desc": "传奇游戏《MONSTER GALAXY》全新升级边玩边赚模式",
  "lpCalculatorNoticeContent1": "如果您已按计算器建议的数额提高充值量且并未进行任何提币，则无需再追加买入即可参与抽奖。您的最终钱包余额将于 {time} 3:30 (UTC) 更新。",
  "lpCalculatorNoticeContent2": "您的每日钱包余额根据每小时钱包余额快照计算。最终钱包余额为每日钱包余额的平均值。",
  "lpCalculatorNoticeTitle": "温馨提示",
  "lpCalculatorSubTitle2Ticket": "获得 2 张抽奖券",
  "lpCalculatorSubTitle3Ticket": "获得 3 张抽奖券",
  "lpCalculatorTicketOpt1": "方式 1：在 {time1} (UTC) 之前再完成 {tradingAmount} USDT 的现货交易",
  "lpCalculatorTicketOpt2": "方式 2：在 {time2} (UTC) 之前再充入 {holdingsAmount} USDT 等值资产",
  "lpCantToSubscribeSameUser": "每位用户只能使用一个已完成身份认证的账户参与当前的 Launchpad 活动。您已使用 UID {uid} 加入 Launchpad，因此无法再使用当前的 Bybit 账户参与当前的 Launchpad 活动。",
  "lpCantToSubscribeTrade": "您的账户余额未达到最低要求。请在下次快照期间进行符合条件的充值。",
  "lpCantToSubscribeUser": "You cannot join the event due to a restriction on your account. The event is not available for institutional users, users associated with institutional users, and managed users.",
  "lpGetTicketCongratulation": "恭喜您获得代币分配抽奖资格！抽奖将于 {time} (UTC) 开始。",
  "lpGetTicketTip": "根据您当前的 VIP 身份、现货交易量和日均持仓量，您将在参与抽奖后获得 {tickets} 张抽奖券。",
  "lpHold": "持仓",
  "lpMoreTicketsBtnUpgradeVip": "升级为 VIP",
  "lpMoreTicketsCountTip": "您的抽奖券/抽奖券数量上限",
  "lpMoreTicketsSubTitle": "您可以通过以下 3 种方式获得抽奖券：成为 VIP、满足现货交易量要求或满足日均持仓量要求。但是，您只能通过这 3 种方式之一获得抽奖券，以所获抽奖券数量最多者为准。",
  "lpMoreTicketsTipBottom": "抽奖券将在用户投入代币参与抽奖后发放。",
  "lpMoreTicketsTipCalculator": "使用<b>计算器</b>计算需要追加的金额。",
  "lpMoreTicketsTipCheck": "查看交易量和持仓量数据",
  "lpMoreTicketsTradeMaxContent": "在 {date1} 到 {date2} 期间，现货交易量至少达到 {TradingReqMax} USDT，或持仓量至少达到 {HoldingReqMax} USDT。",
  "lpMoreTicketsTradeMaxTitle": "现货交易量 ≥ {TradingReqMax} USDT 或持仓量 ≥ {HoldingReqMax} USDT",
  "lpMoreTicketsTradeMinContent": "在 {date1} 到 {date2} 期间，现货交易量至少达到 {TradingReqMin} USDT，或持仓量至少达到 {HoldingReqMin} USDT。",
  "lpMoreTicketsTradeMinTitle": "现货交易量 ≥ {TradingReqMin} USDT 或持仓量 ≥ {HoldingReqMin} USDT",
  "lpMoreTicketsVipContent": "要获得 4 张抽奖券，用户成为 VIP 的时间不能晚于 {date} (UTC)。",
  "lpMoreTicketsVipSuccessContent": "您已成为 Bybit VIP 用户，成功解锁 4 张抽奖券。",
  "lpMoreTicketsVipTitle": "VIP 用户",
  "lpn_active_income": "您的活动收益",
  "lpn_active_rule": "活动条款",
  "lpn_active_status1": "即将到来",
  "lpn_active_status2": "快照期",
  "lpn_active_status3": "快照结算",
  "lpn_active_status4": "认购期",
  "lpn_active_status5": "发放期",
  "lpn_active_status6": "已结束",
  "lpn_add_holdings": "达到 {currency} 持仓量要求方可参与抽奖。",
  "lpn_add_holdings_trading": "达到 {currency} 持仓量和现货交易要求方可参与抽奖。",
  "lpn_add_ticket": "额外抽奖券",
  "lpn_add_ticket_tips": "额外抽奖券将在用户确认参与抽奖后发放。",
  "lpn_allocation_announced_time": "分配结果将在 {time} (UTC) 公布。",
  "lpn_amount_need": "需要追加买入的金额",
  "lpn_asset_table_th1": "时间",
  "lpn_asset_tip": "由于资产计算量较大，您现货账户、理财账户、资金账户及衍生品账户（或统一保证金账户和反向合约账户）中的日均余额更新可能存在延迟。请注意，您充值的金额不一定会立即显示在余额中。",
  "lpn_available_balance": "可用余额（资金账户）：",
  "lpn_available_balance_tip": "可用余额显示的是您可以投入的 MNT 数额上限，或是您的资金账户当前的 MNT 余额，以数值较小的为准。如果您可以投入的 MNT 上限为 30,000，而您当前的 MNT余额为 29,000，那么您的可用余额将会显示 29,000 MNT。",
  "lpn_available_balance_tip_asset": "可用余额显示的是您可以投入的 BIT 数额上限，或是您资金账户当前的 BIT 余额，以数值较小的为准。如果您可以投入的 BIT 上限为 30,000，而您当前的 BIT 余额为 29,000，那么您的可用余额将会显示 29,000 BIT。",
  "lpn_avg_growth": "平均涨幅",
  "lpn_banner_subtitle": "Bybit 明星项目的代币",
  "lpn_banner_title": "率先获得",
  "lpn_btn_experience": "立即加入",
  "lpn_btn_go_kyc": "立即认证",
  "lpn_btn_join_now": "立即投入",
  "lpn_btn_lottery": "立即投入",
  "lpn_btn_my_order": "我的认购历史",
  "lpn_btn_recharge_now": "立即充值",
  "lpn_buy": "买入 {currency}",
  "lpn_buy_explain": "通过信用卡、银行转账、现金余额等买入",
  "lpn_buy_more": "追加买入 {currency}，获得更高项目代币分配额度。",
  "lpn_buy_now": "立即购买",
  "lpn_calculator": "计算器",
  "lpn_calculator_holdings_required": "最低日均持仓量",
  "lpn_calculator_notice": "说明",
  "lpn_calculator_time": "*请务必在 {time} (UTC) 之前完成买入",
  "lpn_calculator_tips1": "根据最新快照结果，您需要额外买入/充值 <b>{holdingsAmount}</b> 并交易 <b>{tradingAmount}</b>，才有资格参与抽奖活动。",
  "lpn_calculator_tips2": "根据最新快照结果，您需要额外买入/充值 <b>{holdingsAmount}</b>，才有资格参与抽奖活动。",
  "lpn_calculator_tips3": "根据最新快照结果，您需要额外交易 <b>{tradingAmount}</b>，才有资格参与抽奖活动。",
  "lpn_calculator_tips4": "根据最新快照结果，您需要买入/充值 <b>{holdingsAmount}</b>，才有资格参与抽奖认购。",
  "lpn_calculator_use": "使用计算器计算需要追加买入的金额。",
  "lpn_calculator_user_holdings": "当前日均持仓量",
  "lpn_calculator_user_trading": "您的日均交易量",
  "lpn_canlendar": "我的快照",
  "lpn_cap_lottery": "每张中签抽奖券的代币分配额度（抽签）",
  "lpn_cap_subscribe": "个人认购上限（认购）",
  "lpn_capita_income": "人均收益",
  "lpn_card_notice1": "请先登录并完成身份认证。",
  "lpn_card_notice8": "快照期已结束。认购和抽奖即将开始。",
  "lpn_card_only_abailable_vip": "仅限 VIP",
  "lpn_card_purchase_limits": "购买限额",
  "lpn_card_vip_level_tip_supreme": "至尊 VIP",
  "lpn_card_vip_level_tip_title": "非 VIP 用户不能参与本次代币分配抽签。",
  "lpn_card_vip_level_tip_user": "VIP 用户",
  "lpn_choose_notice": "您可以用 BIT 申购，或用 USDT 参与抽奖！",
  "lpn_choose_notice_v2": "您可以使用 {currency} 申购，或使用 USDT 参与抽奖！",
  "lpn_commit_more": "立即追加",
  "lpn_community_link": "即刻加入",
  "lpn_community_tip": "瓜分$20万&IPhone 13 Pro",
  "lpn_community_title": "加入Bybit现货交流群，瓜分$20万奖池人人有份，更有iPhone 13 Pro可赢！",
  "lpn_cover_enough_upgrade_vip": "要参与代币分配抽签，您必须在 {time} (UTC) 前升级为 VIP 用户。",
  "lpn_currency": "已投入代币",
  "lpn_deposit": "充值 {currency}",
  "lpn_deposit_explain": "通过钱包或第三方交易平台充值",
  "lpn_deposit_trade": "充值/交易",
  "lpn_deposit_trade_title": "充值并交易，即有机会获得抽奖券",
  "lpn_desc": "参与Bybit Launch系列活动，获得首发新代币",
  "lpn_distribution": "分配",
  "lpn_distribution_time": "分配期",
  "lpn_enable_lottery": "恭喜，您已达到参加抽奖要求。",
  "lpn_enable_subscribe": "恭喜，您已达到认购要求。",
  "lpn_exchange_rate_tip": "${number}（{currency0} 与 {currency} 的汇率将在申购期开始时确定）",
  "lpn_expand_more": "查看更多",
  "lpn_faq": "常见问题",
  "lpn_get_more_ticket": "获得更多抽奖券",
  "lpn_get_ticket": "根据您的注册时间和参与抽奖活动后的日均交易量，您将额外获得 {tickets} 张抽奖券。",
  "lpn_go_trade": "立即交易",
  "lpn_higher_commit": "认购金额越高，可获分配的 {token} 越多，个人上限为 {limitAmount} {token}。",
  "lpn_history": "历史上回报最高的 Launchpad 项目",
  "lpn_holdings": "{currency} 持仓量",
  "lpn_holdings_calculated": "正在计算您的最终快照持仓量。您可在 {time} (UTC) 查看结果。",
  "lpn_holdings_calculator_title": "{currency} 快照持仓量计算器",
  "lpn_holdings_fail": "您资产快照期间的当前持仓量未能达到要求。",
  "lpn_holdings_trading_calculated": "正在计算您的最终快照持仓量和日均交易量。您可在 {time} (UTC) 查看结果。",
  "lpn_holdings_trading_fail": "您资产快照期间的当前持仓量和日均交易量未能达到要求。",
  "lpn_holdings_trading_update": "您的日均持仓量和交易量将于 {date} 3:00 (UTC) 更新。",
  "lpn_holdings_update": "您的日均持仓量将于 {date} 3:00 (UTC) 更新。",
  "lpn_how_join": "参与方式",
  "lpn_index": "主页",
  "lpn_index_avg_tips": "所有 Launchpad 项目上线后第一周的平均回报率。",
  "lpn_input_quantity": "投入总额",
  "lpn_introduce": "CropBytes — 虚拟经济游戏",
  "lpn_introduce_desc2": "CropBytes 是一款基于现实世界农场经济的加密货币游戏。用户运用加密货币，玩赚虚拟世界。效用代币 CBX 是 CropBytes 元宇宙的重要组成部分，与游戏内的所有活动息息相关。",
  "lpn_introduce_desc3": "<br> CropBytes 元宇宙内的价格波动完全取决于供求关系，经济发展形态完全由玩家掌控。 \n \n<br> CropBytes 内设置专属交易所，玩家可在市场中无缝对接，交易资产。\n \n<br> CropBytes 向玩家同时提供同质化与非同质化代币（NFT），从而解决低流动性以及难以频繁交易等问题。",
  "lpn_introduce_t1": "社媒平台",
  "lpn_introduce_t2": "项目简介",
  "lpn_introduce_t3": "项目亮点",
  "lpn_introduce_td3": "{scale} 发行总量",
  "lpn_introduce_td4": "{number} 美元（BIT 和 {currency} 的兑换价格将于认购期前确认）",
  "lpn_introduce_td7": "无锁仓",
  "lpn_introduce_td9": "分配期间",
  "lpn_introduce_th2": "分配总量",
  "lpn_introduce_th3": "初始流通量",
  "lpn_introduce_th4": "价格",
  "lpn_introduce_th5": "Launchpad 的分配总量",
  "lpn_introduce_th6": "个人分配上限",
  "lpn_introduce_th7": "代币锁仓期",
  "lpn_introduce_th8": "代币类型",
  "lpn_introduce_th9": "代币分配",
  "lpn_investment": "您的投资",
  "lpn_invite": "邀请好友",
  "lpn_invite_ad": "邀请好友，赚取<b>最高 120 MNT</b>！",
  "lpn_invite_ad2": "邀请好友交易现货，赚取高达 30% 佣金！",
  "lpn_invite_go": "立即邀请",
  "lpn_invite_now": "邀请好友",
  "lpn_invite_rule": "规则说明",
  "lpn_invite_rule1": "1. 如何参与 Launchpad 推荐计划？\n- 将邀请链接分享给好友，邀请他们注册 Bybit 账户并报名参加即将开始的 Lauchpad 活动。每成功邀请一位好友，即可获得一定数量的 MNT 奖励。 - 受邀好友应注册 Bybit 账户，并参加本次 Launchpad 的代币分配申购或锦鲤抽奖活动。\n- Lauchpad 活动的有效期为官方宣布开始至申购期结束。请在社交媒体关注 Bybit 或访问 Launchpad 主页，查看活动时间。\n- 每场 Lauchpad 活动可邀请 10 位好友，您最高可获得 120 MNT。\n- 如果受邀好友成为 Bybit 代理，则您不能获得奖励。",
  "lpn_invite_rule2": "2.奖励如何分发？\n- 如果您已成功邀请任何符合条件的新用户参加活动，则奖励的 MNT 总额将在 Launchpad 活动结束 1 个月后计入您的资金账户。",
  "lpn_invite_rule2_asset": "<b>2. 奖励的具体发放方式如何？</b>\n- 如果您已成功邀请任何符合条件的新用户参加活动，则奖励的 BIT 总额将在 Launchpad 活动结束后 1 个月计入您的资金账户。",
  "lpn_invite_tab1": "分享链接",
  "lpn_invite_th1": "累计推荐好友人数",
  "lpn_invite_th2": "单个成功推荐奖励",
  "lpn_invite_title": "推荐好友同赚 BIT",
  "lpn_invite_title_mnt": "邀请好友，赢取 MNT",
  "lpn_is_high_vip_tip_text": "您已达到本次代币分配抽奖的最高购买限额。您的购买限额为 {amount} {currency}。",
  "lpn_issue_items_total": "项目",
  "lpn_join": "立即加入",
  "lpn_join_ad": "参与 Bybit Launchpad 活动，率先获得高潜力项目代币！",
  "lpn_join_go": "立即参与",
  "lpn_join_step": "活动时间",
  "lpn_join_step1_desc": "在<b>{date}</b>期间，您的现货账户和理财账户中的 BIT 日均余额必须达到或高于 {amount}，相关数值将向下取整。",
  "lpn_join_step1_desc_v2": "1. The daily average holdings of the committed token (MNT or USDT) and trading volume during the snapshot period must be equal to or greater than the minimum threshold amount. ",
  "lpn_join_step1_title": "资产快照期",
  "lpn_join_step2_desc": "若要向新项目投入 BIT，您必须在认购期内点击“立即认购”。您可以投入的 BIT 数量上限取决于现货账户和理财账户于 5 天持仓快照期的 BIT 日均持仓量。请注意，参与认购后，平台将暂时锁定您投入的 BIT 数额，在最终发放 {currency} 前无法划转、提币或交易。",
  "lpn_join_step2_title": "认购期",
  "lpn_join_step3_desc": "{currency} 最终分配数量 =（您投入的 BIT 数量 / 所有参与者投入的 BIT 数量）* 为项目分配的 {currency} 总量。请注意，您可以领取的 {currency} 上限为 {limit}，超出限额的部分将分配给尚未达到上限的参与者。根据最终的 {currency} 分配结果，系统将从投入的金额中扣除相应的 BIT 等值金额，而分配到的 {currency} 和剩余的 BIT 将返还至您的现货账户。",
  "lpn_join_step3_title": "分配期",
  "lpn_join_step4_date": "如果达到流动性条件，新代币预计将于 {date} （UTC）上线 Bybit 现货交易平台。",
  "lpn_join_step4_title": "上线时间",
  "lpn_kyc_lottery": "请完成 1 级 KYC，才能参与抽奖。",
  "lpn_kyc_subscribe": "请完成 1 级 KYC，才能参与认购。",
  "lpn_launchpad": "Launchpad",
  "lpn_launchpool": "FreshCut Diamond (FCD)",
  "lpn_launchpool_desc": "FCD 是 FreshCut 游戏内容平台的社区代币，用户可在社区中创作赚币或参与赚币，平台还会用代币来奖励创作者。",
  "lpn_launchpool_title": "质押赚取免费代币",
  "lpn_learn_join": "立即开始",
  "lpn_link_bps": "白皮书",
  "lpn_link_research": "研究报告",
  "lpn_link_rule": "活动规则",
  "lpn_link_website": "官网",
  "lpn_list": "列表页",
  "lpn_log_snapshot": "登录即可查看您的最新快照结果。",
  "lpn_login": "登录",
  "lpn_lottery": "锦鲤抽奖",
  "lpn_lottery_announced_time": "抽奖结果将在 {time} (UTC) 公布。",
  "lpn_lottery_calculator_notice1": "日均持仓量将根据您的钱包余额每小时快照计算得出。最终账户持仓量为您每日钱包余额的平均值。",
  "lpn_lottery_calculator_notice2": "正在计算您的最终账户持仓量。您可在 {time} (UTC) 查看结果。",
  "lpn_lottery_calculator_notice3": "日均交易量将根据资产快照期间您现货交易量的每小时快照计算得出。",
  "lpn_lottery_card_desc": "日均持仓量和交易量达到最低要求后，投入 {minPledgeAmount} {currency} 即可获得一张抽奖券，更有机会赢取 {token}！每张抽奖券抽中后可赢取 {limitAmount} {token}！",
  "lpn_lottery_card_desc_v2": "日均持仓量达到要求后，投入 {minPledgeAmount} {currency} 即可获得一张抽奖券，有机会赢取 {token}！每张抽奖券中奖后均可获得 {limitAmount} {token}！",
  "lpn_lottery_chosen": "两项活动二选一。您选择投入 {currency} 以获得抽奖券。",
  "lpn_lottery_confirm_tips": "投入 {amount1}{currency} 获取抽奖券，中奖后可赢取 {amount2} 新代币！",
  "lpn_lottery_currency": "使用 {currency} 进行抽奖",
  "lpn_lottery_desc": "投入 {currency} 以赢取项目代币分配权。",
  "lpn_lottery_enbale": "恭喜，您已满足抽奖要求。抽奖将于 {time} (UTC) 开始。",
  "lpn_lottery_error_tips": "选择用{currency1} 购买抽奖券后，您不能使用 {currency2} 认购项目代币分配。",
  "lpn_lottery_no": "您的抽奖号码",
  "lpn_lottery_not_cover_min_valom": "抱歉，您未能达到本次 Launchpad 的最低要求。请在下次 Launchpad 快照期结束前达到现货交易量要求，或升级为 VIP 用户。",
  "lpn_lottery_rate": "中奖概率",
  "lpn_lottery_start_time_tip": "抽签将于 {time1} (UTC) 开始。",
  "lpn_lottery_total": "分配总量（抽奖）",
  "lpn_lottery_trading_tips": "由于资产计算量较大，您的日均交易量更新可能会存在延迟，交易订单不一定会立即显示在日均交易量中。",
  "lpn_lucky_limit": "个人上限（幸运抽奖）",
  "lpn_min_holdings": "最低日均持仓量",
  "lpn_min_holdings_tips": "日均持仓量将根据资产快照期间账户余额的每小时快照计算得出。",
  "lpn_min_input": "低于最小投入数量 {quantity}{coin}",
  "lpn_more_ticket_title": "如何获取更多抽奖券",
  "lpn_more_trade": "交易量越大，获得的抽奖券就越多。",
  "lpn_more_trade_content": "快照期间（{date1} ~ {date2}），达到日均现货交易量要求的用户将获得额外抽奖券。",
  "lpn_new_rule1": "1.所有参与用户需遵守 Bybit 条款与条件。",
  "lpn_new_rule2": "2.Bybit 有权取消利用恶意行为获取盈利的用户的参与资格，包括开设多账户以牟取追加赠金以及其他涉及非法、欺诈或造成有害影响的行为。",
  "lpn_new_rule3": "3.Bybit 保留对本次活动的最终解释权。如果您有任何疑问，请联系我们的客服团队。",
  "lpn_new_rule4": "4.Bybit 有权修改本次活动的条款。若有更改，恕不另行通知。",
  "lpn_new_rule5": "5.本网站所载内容不构成您在美国或进入美国（或其他从事此类活动非法的司法权区）境内向任何美国人或为其账户出售证券的邀约。\nBIT代币转让受适用法律的相关规定规限。在任何情况下，除非适用《1933年美国证券法》（修订版）的豁免规定，或属于不受登记规定约束的交易，您不会在美国境内，或向任何美国人或为其账户或利益，重新发售、转售或转让任何 BIT 代币。任何于美国境内进行的任何BIT代币公开发售将以招股章程的方式进行，您可向发行方或代币销售持有者索取，其中载有本公司及管理层详细资料以及财务报表。",
  "lpn_new_rule5_v2": "本网站中包含的内容不构成在美国或相关行为属于非法范畴的任何其他司法辖区内发售或销售证券，亦不代表美国或此类司法辖区居民发售或销售证券或是使其受益。 \n\n根据适用法律规定，{currency0} 代币划转可能需要遵循法律限制。在任何情况下，{currency0} 代币均不会在美国境内再次发售、转售或划转，亦不代表美国居民再次发售、转售或划转或是使其受益，美国《1933 年证券法》注册登记要求豁免的情况/交易无需遵循相关要求的情况除外。{currency0} 代币在美国境内的任何公开发售都将通过公开发行的方式完成，用户可通过发行方或所售代币持有者获取代币，并将包含关于公司和管理层的详细信息，此外还会提供财务报表。",
  "lpn_new_user": "新用户将额外获得 1 张抽奖券。",
  "lpn_new_user_content": "活动期间（{date1} - {date2}）注册的新用户将额外获得 1 张抽奖券。",
  "lpn_not_high_vip_tip_text": "要将您的购买限额提升至 {amount} {currency}，请在 {time} UTC 之前完成 VIP 升级。",
  "lpn_not_vip_tip_text": "要参与代币分配抽签，您必须在 {time} (UTC) 前升级为 VIP 用户。",
  "lpn_notice_13": "快照期已结束。认购即将开启。",
  "lpn_notice10": "本期活动已结束。",
  "lpn_notice11": "您现在可查看所获分配额度！新代币即将上线 Bybit 现货交易平台。",
  "lpn_notice12": "资产统计中。追加充值 {currency} 以获得 {currency} 分配资格。您当天的账户余额快照将于次日更新。",
  "lpn_notice14": "可购买抽奖券。投入 {currency} 以获得抽奖券。",
  "lpn_notice15": "两项活动二选一。",
  "lpn_notice16": "您的抽奖号为 {number}。",
  "lpn_notice17": "选择交易对，开始交易！",
  "lpn_notice2": "只差一步即可参加活动。",
  "lpn_notice3": "资产快照期即将开始，请确保账户余额充足。",
  "lpn_notice6": "资产统计中。追加充值 {currency} 以获得更多项目代币分配额度。您当天的账户余额快照将于次日更新。",
  "lpn_notice7": "很遗憾，您的日均账户余额不满足活动要求，请关注我们的下期活动",
  "lpn_notice8": "认购进行中。投入 {currency} 以认购。",
  "lpn_notice9": "追加 {currency} 以获得更大项目代币分配额度。",
  "lpn_obtain_lottery_qualification": "恭喜！您符合投入 {amount} {currency} 参与代币分配抽签的条件。",
  "lpn_ok": "确定",
  "lpn_one_progress_info": "结果预期公布于",
  "lpn_one_progress_title": "代币分派中……",
  "lpn_only_vip_can_join": "仅 VIP 用户可参与本次抽签。",
  "lpn_order_amount": "投资",
  "lpn_order_btn": "我的认购",
  "lpn_order_btn_all": "全部",
  "lpn_order_btn_cancel": "取消",
  "lpn_order_btn_confirm": "确认",
  "lpn_order_dialog_abailable_balance": "可用余额（资金账户）",
  "lpn_order_dialog_commit_amount": "投入数额",
  "lpn_order_dialog_title": "详情",
  "lpn_order_max": "可投资的最大金额",
  "lpn_order_max_tip": "您可以投入的 BIT 数额上限取决于您在 5 天快照期内记录的日均 BIT 余额。",
  "lpn_order_max_tip_v2": "您可以投入的 MNT 数额上限取决于您在 5 天快照期内记录的日均 MNT 余额。",
  "lpn_order_submit_success": "成功！",
  "lpn_order_submit_success_desc": "您已向所选项目投入 {num} {currency}。",
  "lpn_order_submit_success_desc1": "您已成功参与抽奖。",
  "lpn_order_tips": "登录后方可查看订单历史。",
  "lpn_participant": "参与人数",
  "lpn_participants": "参与者",
  "lpn_paymeet_failed_dialog_buy_btn": "买入 {currency}",
  "lpn_paymeet_failed_dialog_content": "您的资金账户余额不足。要继续认购，您需要额外买入或充值 {amount} {currency}。",
  "lpn_paymeet_failed_dialog_deposit_btn": "充值 {currency}",
  "lpn_paymeet_failed_dialog_title": "付款失败",
  "lpn_price": "价格",
  "lpn_product_life": "活动时间",
  "lpn_profit": "第一周平均收益",
  "lpn_profit_tips": "第一周平均收益 = 上线后第一周的平均价格/发行价 *100%",
  "lpn_project_desc": "迈入元宇宙，建设加密农场",
  "lpn_project_info": "项目介绍",
  "lpn_project_status0": "资产快照期将开始于",
  "lpn_project_status1": "距离认购开始",
  "lpn_project_status2": "距离认购截止",
  "lpn_project_status3": "距离分配结束",
  "lpn_project_status4": "已结束",
  "lpn_record_endtime": "结束日期",
  "lpn_record_name": "项目",
  "lpn_record_name_tip": "输入项目名称",
  "lpn_record_starttime": "开始日期",
  "lpn_record_state0": "待定",
  "lpn_record_state1": "分配中",
  "lpn_record_state2": "完成",
  "lpn_record_th1": "时间",
  "lpn_record_th3": "已投代币金额",
  "lpn_record_th3_m": "投入 {currency}",
  "lpn_record_th4": "价格",
  "lpn_record_th5": "抵扣代币金额",
  "lpn_record_th6": "代币分配数量",
  "lpn_record_th7": "状态",
  "lpn_records": "记录",
  "lpn_register": "注册",
  "lpn_register_ticket": "成功注册。您已获得 1 张抽奖券。",
  "lpn_required_holdings": "日均持仓量要求",
  "lpn_required_trading": "日均交易量要求",
  "lpn_required_trading_tips": "日均交易量将根据资产快照期间您现货交易量的每小时快照计算得出。",
  "lpn_required_tradings": "现货交易量要求",
  "lpn_reset": "重置",
  "lpn_restricted_country": "受限制国家/地区",
  "lpn_restricted_country_tip": "Bybit 不向美国、中国大陆、新加坡、魁北克（加拿大）、朝鲜、古巴、伊朗、克里米亚、塞瓦斯托尔及苏丹的居民或公民提供服务或产品。",
  "lpn_result_time": "分配结果",
  "lpn_result_title": "您的投资结果",
  "lpn_rewards_check_reason": "失败原因",
  "lpn_rewards_default_name": "过往 Launchpad 活动",
  "lpn_rewards_faile_reason": "您目前不符合领取空投奖励的条件。请向 Bybit 提交申诉，并在“案例类型”下选择“活动”、“奖励”和“Launchpad”。",
  "lpn_rewards_orders": "我的推荐奖励",
  "lpn_rewards_request": "提交申诉请求",
  "lpn_rewards_source1": "{uid} 参与了活动",
  "lpn_rewards_source2": "过往用户活动",
  "lpn_rewards_status_faile": "失败",
  "lpn_rewards_status_pending": "处理中",
  "lpn_rewards_status_success": "已发放",
  "lpn_rewards_status_tips": "奖励将在 Launchpad 活动结束后的 7 个工作日内发放至现货账户。如未收到奖励，请点击“失败原因”了解详情。",
  "lpn_rewards_status_tips_asset": "奖励将在 Launchpad 活动结束后 7 个工作日内发放至您的资金账户。如未收到奖励，请点击“失败原因”了解详情。",
  "lpn_rewards_th_event": "Launchpad 活动",
  "lpn_rewards_th_rewards": "奖励",
  "lpn_rewards_th_source": "用户活动",
  "lpn_rules": "活动规则",
  "lpn_scroll_load": "向下滚动查看更多",
  "lpn_select_deposit": "选择充值方式",
  "lpn_share_earn": "邀好友，赚奖励",
  "lpn_share_img_content": "邀请好友，最高可获 120 MNT！",
  "lpn_share_text": "参与 Bybit Launchpad 活动，率先获得高潜力项目代币！点击此处： {link}",
  "lpn_share_text_label": "设置个性化邀请信息",
  "lpn_snapshot_buy_currency": "立即买入或充值 {currency} ，即可认购更多代币。",
  "lpn_snapshot_desc_content1": "5 天资产快照期间，您现货账户、理财账户、资金账户及合约账户（或统一保证账户）中的日均持仓量将通过每小时资产快照进行记录。当天的日均持仓量将于次日 3:00 (UTC) 更新。 \n\n举例说明：假设 Bob 在 10 月 28 日注册了 Bybit 账户，并从 21:00 (UTC) 开始每小时为现货账户充值 100 BIT。Bob 的每小时余额快照记录如下：21:00 (UTC) 100 BIT，22:00 (UTC) 200 BIT，23:00 (UTC) 300 BIT。因此，10 月 28 日 Bob 现货账户中的 BIT 日均持仓量将达到 25 BIT*。 \n\n*[(100 + 200 + 300)/24] = 25 \n\n10 月 29 日 3:00 (UTC) 之后，Bob 会看到他 10 月 28 日的 BIT 持仓量（现货账户）更新为 25 BIT。",
  "lpn_snapshot_desc_content1_asset": "5 天资产快照期间，您的资金账户、现货账户及合约账户（或统一保证金账户、统一交易账户和反向合约账户）中的日均持仓量将通过每小时资产快照进行记录。当天的日均持仓量将于次日 3:00 (UTC) 更新。 \n\n举例说明： \n假设 Bob 在 10 月 28 日注册了 Bybit 账户，并从 21:00 (UTC) 开始每小时为资金账户充值 100 BIT。Bob 的每小时余额快照记录如下：21:00 (UTC) 100 BIT，22:00 (UTC) 200 BIT，23:00 (UTC) 300 BIT。因此，10 月 28 日 Bob 资金账户中的 BIT 日均持仓量将达到 25 BIT。 \n\n*[(100 + 200 + 300)/24] = 25 \n\n10 月 29 日 3:00 (UTC) 之后，Bob 会看到其 10 月 28 日的 BIT 日均持仓量（资金账户）更新为 25 BIT。",
  "lpn_snapshot_desc_content2": "4 天快照期内，您现货交易、现货跟单交易、网格机器人、定投机器人、现货杠杆交易和杠杆代币的综合日均交易量将通过每日快照进行记录。其中包括您所有的买入和卖出交易。请注意，衍生品交易的交易量不计入其中。您当天的综合日均交易量将于次日 3:00 (UTC) 更新。\n\n对于以 USDT 计价的交易对，交易量按所有已执行 USDT 订单的价值总和计算；对于以非 UDST 计价的交易对，交易量将按当日收盘价换算为 USDT。\n\n假设 Bob 在 10 月 28 日注册了 Bybit 账户，然后在 21:00 (UTC) 进行了 100 USDT 的现货交易，又在 22:00 (UTC) 进行了 200 USDT 的现货交易。他的日均交易量快照将记录为 300 USDT。在本例中，他在快照期间的最终日均交易量为 60 USDT*\n\n*(100 + 200) / 5 = 60\n\n10 月 29 日 3:00 (UTC) 后，Bob 将看到他 10 月 28 日的日均交易量更新为 60 USDT。",
  "lpn_snapshot_desc_content2_v2": "在 {snapshot_days} 天快照期内，您现货交易、现货跟单交易、网格机器人、定投机器人、现货杠杆交易和杠杆代币的综合累计交易量将通过每日快照进行记录，其中包括您所有的买入和卖出交易。请注意，衍生品交易量不计入其中。您当天的综合日均交易量将于次日 3:00 (UTC) 更新。\n\n对于以 USDT 计价的交易对，交易量为所有已成交 USDT 订单的订单价值之和。对于非 USDT 计价的交易对，交易量将根据当天收盘价折算为 USDT。\n\n假设 Bob 在 10 月 28 日注册了 Bybit 账户，然后在 21:00 (UTC) 进行了 100 USDT 的现货交易，又在 22:00 (UTC) 进行了 200 USDT 的现货交易。在这种情况下，他在快照期间的累计总交易量将为 300 USDT。\n\n100 + 200 = 300\n\n10 月 29 日 3:00 (UTC) 之后，Bob 会看到他 10 月 28 日的累计交易量更新为 300 USDT。",
  "lpn_snapshot_desc_content3": "资产快照期间，您现货账户、理财账户、资金账户及合约账户（或统一保证账户）的日均持仓量必须达到或超过最低阈值金额，并向下取整。\n\n您现货账户、理财账户、资金账户及合约账户（或统一保证金账户）中的日均持仓量将于每天 3:00 (UTC) 更新。但是，由于计算量较大，您的日均持仓量更新可能会存在延迟。",
  "lpn_snapshot_desc_content3_asset": "资产快照期间，您的资金账户、现货账户及合约账户（或统一保证金账户、统一交易账户和反向合约账户）中的日均持仓量必须达到或超过最低阈值金额，并向下取整。\n\n您的资金账户、现货账户及合约账户（或统一保证金账户、统一交易账户和反向合约账户）中的日均持仓量将于每天 3:00 (UTC) 更新。但是，由于计算量较大，您的日均持仓量更新可能会存在延迟。",
  "lpn_snapshot_desc_title1": "持仓量是如何计算的？",
  "lpn_snapshot_desc_title1_v2": "如何计算参与 MNT 申购或 USDT 抽奖的持仓量？",
  "lpn_snapshot_desc_title2": "日均交易量是如何计算的？",
  "lpn_snapshot_desc_title2_v2": "如何计算现货交易量，以确定我是否有资格获得 2 张或 3 张抽奖券？",
  "lpn_snapshot_desc_title3": "快照规则",
  "lpn_snapshot_holding": "持仓信息",
  "lpn_snapshot_holdings_title": "{currency} 持仓量快照",
  "lpn_snapshot_th_trading": "交易量",
  "lpn_snapshot_trading": "交易量详情",
  "lpn_snapshot_trading_title": "交易量快照",
  "lpn_snapshot_update_time": "将于 {date} 3:00 (UTC) 更新",
  "lpn_snapshots": "资产快照",
  "lpn_snapshots_time": "资产快照期",
  "lpn_spot_trading": "现货交易量",
  "lpn_step_tips1": "<b>满足条件：</b>在快照期结束前充值 BIT 或 USDT，确保钱包余额达到认购或抽奖要求！",
  "lpn_step_tips1_v2": "<b>满足条件：</b>在快照期结束前充值 MNT 或 USDT，确保钱包余额达到申购或抽奖要求！",
  "lpn_step_tips2": "<b>投入代币：</b>投入 BIT 即可直接认购代币分配，投入 USDT 即有机会赢取项目代币分配额度。",
  "lpn_step_tips2_v2": "<b>投入代币：</b>投入 MNT 即可直接申购代币分配，投入 USDT 即有机会赢取项目代币分配额度。",
  "lpn_step_tips3": "<b>分配期：</b>系统将在分配期为认购用户分配代币，并为参与抽奖的用户抽取分配额度。",
  "lpn_step_tips4": "<b>查看结果：</b>在结果公布后查看您的代币认购分配或中奖所获分配额度。现在就可以使用您获得的新代币进行交易了！",
  "lpn_sub_tip_text": "立即订阅，随时获悉 Launchpad 活动更新！",
  "lpn_subscribe": "认购",
  "lpn_subscribe_chosen": "两项活动二选一。您选择投入 {currency} 以认购。",
  "lpn_subscribe_currency": "使用 {currency} 申购",
  "lpn_subscribe_desc": "投入 {currency} 进行申购，获得代币分配权。",
  "lpn_subscribe_error_tips": "选择用 {currency1} 认购项目代币分配后，则无法使用 {currency2} 购买抽奖券。",
  "lpn_subscribe_total": "分配总量（认购）",
  "lpn_subscription": "认购",
  "lpn_subscription_holding_tips": "由于资产计算量较大，您现货账户、理财账户、资金账户及合约账户（或统一保证金账户）的日均持仓量更新可能会存在延迟，充值金额不一定会立即显示在余额中。",
  "lpn_subscription_holding_tips_asset": "由于资产计算量较大，您的资金账户、现货账户及合约账户（或统一保证金账户、统一交易账户和反向合约账户）的日均持仓量更新可能会存在延迟，充值金额不一定会立即显示在余额中。",
  "lpn_subscription_time": "认购期",
  "lpn_subscription_time2": "认购或抽奖",
  "lpn_subscriptions_orders": "我的认购",
  "lpn_subscrption_card_desc": "日均持仓量达到最低要求后，至少投入 {minPledgeAmount} {currency} 即可认购 {token}（每人认购上限为 {limitAmount} {token}）。",
  "lpn_tail_digit": "{num} Tail Digit",
  "lpn_tail_digit_num": "后{number}位尾数",
  "lpn_tail_digit_num1": "最后一位数字",
  "lpn_tail_digits": "中奖号码",
  "lpn_tail_digits_th1": "匹配",
  "lpn_tail_digits_th2": "中奖号码",
  "lpn_time_label": "日期",
  "lpn_token_calculation": "代币分配中……",
  "lpn_total_amount": "总投资",
  "lpn_total_funds_raised": "投入总额（美元）",
  "lpn_total_rewards": "总奖励 (MNT)",
  "lpn_trade": "交易",
  "lpn_trade_desc": "在现货市场上买卖加密货币。",
  "lpn_trade_detail_entry": "交易量详情",
  "lpn_trade_statistics_rule_tips": "快照结束日期（{date1} 至 {date2} UTC）前 30 天内的所有现货交易量都将计入现货交易量要求。其中包括现货交易、现货杠杆交易、杠杆代币交易，以及通过现货网格机器人和定投机器人执行的交易。上述时间范围内完成的所有买币和卖币交易都将纳入计算。",
  "lpn_trade_volume_cover_enough": "您已达到参与代币分配抽签所需的日均持仓量。",
  "lpn_trade_volume_not_enough": "抱歉，您快照结束日期 ({date1} ~ {date2} (UTC) 前 30 天内的现货交易量未能达到要求。使用计算器计算需要追加买入的金额。",
  "lpn_trade_volume_update_time": "您的现货交易量将于 {date} 3:00 (UTC) 更新。",
  "lpn_trading_calculator_title": "日均交易量计算器",
  "lpn_trading_fail": "您当前的日均交易量未能达到要求。",
  "lpn_two_progress_info": "分派预期将完成于",
  "lpn_two_progress_title": "分配和抽奖进行中……",
  "lpn_unable_snapshot": "您的账户余额未达到最低要求。请在下次快照期间进行符合条件的充值或提升您的交易量。",
  "lpn_unsub_dialog_cancel": "取消",
  "lpn_unsub_dialog_confirm": "确认",
  "lpn_unsub_dialog_text": "您确定要取消订阅吗？取消订阅后，您不会再收到关于上线活动、快照、申购和代币分配结果的 Launchpad 通知。",
  "lpn_unsub_dialog_title": "注意",
  "lpn_up_to": "最高 120 MNT",
  "lpn_upgrade_to_vip": "升级为 VIP",
  "lpn_upgrade_to_vip_current_level": "当前等级",
  "lpn_upgrade_vip_btn_text": "VIP 升级",
  "lpn_upper_limit": "个人认购上限",
  "lpn_user_center": "用户中心",
  "lpn_view_all": "查看所有项目",
  "lpn_view_details": "查看详情",
  "lpn_vip_calculator_notice1": "如果您已按计算器建议的数额提高交易量，则无需额外交易量即可参与抽签。您的最终交易量将于 {time} 3:30 (UTC) 更新。",
  "lpn_vip_calculator_notice2": "快照结束日期（{date1} 至 {date2} UTC）前 30 天内的所有现货交易量都将计入现货交易量要求。其中包括现货交易、现货杠杆交易、杠杆代币交易，以及通过现货网格机器人和定投机器人执行的交易。上述时间范围内完成的所有买币和卖币交易都将纳入计算。请注意，衍生品交易的交易量不计入其中。您当天的综合日均交易量将于次日 3:00 (UTC) 更新。",
  "lpn_vip_calculator_user_trading_vol": "您的交易量",
  "lpn_vip_card_desc": "交易量达到要求后，根据您的 VIP 等级，投入 {amount1} 到 {amount2} {currency}，即可获得一张抽奖券，有机会赢取 {token}！中签后，您将收到 {limitAmount1} 到 {limitAmount2} {token}，具体取决于您的已投代币数额！",
  "lpn_vip_detail_card_login_tip": "登录查看购买限额。",
  "lpn_vip_last_day_time": "*必须在 {time} (UTC) 之前达到要求。",
  "lpn_vip_level_token_tip": "（每位中签用户可获得 {amount} {token}）",
  "lpn_vip_lottery_title": "要参与代币分配抽签，您必须达到现货交易量要求。",
  "lpn_vip_not_join_account_tip": "由于账户限制，您不符合参与本活动的条件。本活动不面向机构用户、机构用户关联用户及托管用户开放。",
  "lpn_vip_not_kyc_tip1": "正在计算您的最终交易量。",
  "lpn_vip_not_kyc_tip2": "您可在 {time} (UTC) 查看结果。",
  "lpn_vip_order_dialog_title": "投入 {amount1} {currency} 获取抽奖券，中签后可获得 {amount2} 新代币！",
  "lpn_vip_project_title": "投入 {token}，参与代币分配抽签。",
  "lpn_vip_trade_btn": "交易",
  "lpn_vip_trade_val_fail": "抱歉，您未能达到本次 Launchpad 的最低要求。请在下次 Launchpad 快照期结束前达到现货交易量要求，或升级为 VIP 用户。",
  "lpn_vip_user_need_trading_vol_tip": "根据最新快照结果，您需要额外交易 <b>{amount} USDT</b>，才有资格参与抽签活动。",
  "lpn_vip_volume_calculator": "交易量计算器",
  "lpn_win_benefits": "每位中奖者所获分配额度",
  "lpn_win_prize": "每张中签抽奖券的代币分配额度",
  "lpn_your_card_purchase_limits": "您的购买数额",
  "lpSnapshotDescContent3": "在 {snapshot_days} 天快照期内，您资金账户、现货账户及合约账户（或统一交易账户和反向合约账户）中所有币种的日均持仓量将通过每小时资产快照进行记录。当天的日均持仓量将于次日 3:00 (UTC) 更新。\n\n对于非 USDT 资产，持仓量将根据当天收盘价折算为 USDT。\n\n假设 Bob 在 10 月 28 日注册了 Bybit 账户，并从 21:00 (UTC) 开始每小时为资金账户充值 100 MNT。Bob 的每小时余额快照记录如下：21:00 (UTC) 100 MNT，22:00 (UTC) 200 MNT，23:00 (UTC) 300 MNT。因此，10 月 28 日 Bob 资金账户中的 MNT 日均持仓量将为 25 MNT。\n\n[(100 + 200 + 300) / 24] = 25\n\n假设 10 月 28 日 MNT/USDT 的收盘价为 1 USDT。10 月 29 日 3:00 (UTC) 之后，Bob 会看到他 10 月 28 日的日均持仓量更新为 25 USDT。\n\n25 * 1 = 25 USDT",
  "lpSnapshotDescTitle1Lottery": "How are my holdings calculated for MNT subscription or USDT lottery?",
  "lpSnapshotDescTitle3Lottery": "如何计算持仓量，以确定我是否有资格获得 2 张或 3 张抽奖券？",
  "lpSnapshotTabTitle": "总持仓量快照",
  "lpSnapshotTradingTh": "总持仓量",
  "lpTickets": "抽奖券",
  "lpTrade": "交易",
  "lpTradeOrDeposit": "交易/充值",
  "lpTransfer": "划转",
  "MARKET": "市场价格",
  "max": "最大",
  "mntSubscriptionJoinedNotice": "您已参与 MNT 申购，因此您当前不能参与抽奖。",
  "more": "更多",
  "myBenefits": "我的权益",
  "mySnapshotData": "我的快照数据",
  "needAdditionalAmountForLottery": "您需要追加买入/充值 <b>{additional_amount} {currency}</b>，才符合抽奖参与资格。所显示的USDT仅是您主账户中当前所持有的资产（资金账户， 现货账户与衍生品账户/ 统一交易账户与反向衍生品账户）， 不包含子账户中的资产与质押在Bybit储蓄中的资产。 具体的快照逻辑请参考下面的详细说明。",
  "network_error": "请求失败，请稍后重试。",
  "NEW": "待成交",
  "next_page": "下一页",
  "no_more_text": "没有更多内容",
  "nodata": "暂无数据",
  "none": "无",
  "nonUsdtAssetsConversion": "对于非 USDT 资产，持仓量将根据当天收盘价折算为 USDT。",
  "nonUsdtPairsTradingVolumeConversion": "对于非 USDT 计价的交易对，交易量将根据当天收盘价折算为 USDT。",
  "notCountedTradingVolume": "以下产品的交易量不计算在内。",
  "notice": "注：",
  "notIncludedTradingTypes": "所有现货交易、现货跟单交易、网格机器人、定投机器人、现货杠杆交易、杠杆代币和 API 交易的买卖均不计算在内。",
  "officalWebsite": "官网",
  "og_title": "{symbol} | 买卖交易，尽享低手续费 | Bybit 现货",
  "ongoing": "进行中",
  "onGoing": "进行中",
  "operationSuccess": "成功",
  "or": "或",
  "orderAmount": "订单总额",
  "orderBook": "订单表",
  "orderHistory": "订单历史",
  "orderId": "订单单号",
  "orderType": "订单类型",
  "otcErrorInfo": "抱歉，您开通了机构借贷，无法进行杠杆交易。",
  "outstanding": "待还",
  "pastPerformance": "已发售项目",
  "previous_page": "上一页",
  "price": "价格",
  "quantity": "数量",
  "referAndEarn": "邀好友，赚奖励",
  "referFriendsEarnToget": "邀请好友，共同赚币！",
  "referralHistRules": "推荐记录与规则",
  "registeredSuccessfully": "报名成功",
  "registerEventIdentityVerification": "您需要完成 1 级身份认证，才能报名参与本活动。",
  "registerNow": "立即报名",
  "registerToJoinLottery": "现在报名，随后参与抽奖。",
  "registerToJoinSubscription": "现在报名，随后参与申购。",
  "reset": "重置",
  "resultsAnnouncementTime": "结果公布倒计时",
  "resultsWillBeAnnounced": "结果公布倒计时",
  "reverse_contract_account": "反向合约账户",
  "riskWarning": "确认弹窗",
  "saleEndsIn": "发售结束倒计时",
  "saleEndsIn1": "发售结束倒计时",
  "saleInfo": "发售信息概览",
  "saleStartsIn": "发售开始倒计时",
  "saleStartsIn1": "发售开始倒计时",
  "search": "搜索",
  "secureEarlyAccess": "率先获得 Bybit 明星项目的代币！您可以使用 MNT 申购所发售代币，或使用 USDT 参与代币分配抽奖。您在资产快照期内持有的代币数量将决定您可申购的代币数量以及您在代币分配抽奖中赢得代币分配权的几率。",
  "shareAndEarn": "分享赚币",
  "sharePrizePool": "邀请好友参与活动，瓜分 {prizepool} {token} 奖池！",
  "shareToEarn": "分享赚币",
  "side": "方向",
  "signup": "注册",
  "snapshotBalancesCounted": "资产快照期间，哪些余额会计算在内？",
  "snapshotPeriodRecord": "资产快照期间 ({time1} – {time2} UTC)，您资金账户、现货账户及合约账户（或统一交易账户和反向合约账户）中的资产将通过每小时快照记录。",
  "snapshotPeriodTradingVolumeRecord": "{x} 天快照期间，以下产品的累计交易量总和将通过每日快照记录。",
  "snapshotPeriodVolumeRecord": "<p>3. 快照期内，现货交易、现货跟单交易、网格机器人、定投机器人、现货杠杆交易和杠杆代币的综合累计交易量将通过每日快照进行记录，其中包括所有买卖交易。对于以 USDT 计价的交易对，交易量为所有已成交 USDT 订单的订单价值之和。对于非 USDT 计价的交易对，交易量将根据当天收盘价折算为 USDT。请注意，通过 API 交易、衍生品交易、跟单交易 Pro 以及 0 手续费交易对产生的交易量不会计入活动。</p>",
  "snapshotResultsPeriodUtc": "资产快照期 {time1} – {time2} (UTC) 快照结果如下：",
  "snapshotsRules": "快照规则",
  "spot_account": "现货账户",
  "spotAccount": "现货账户",
  "spotCopyTrading": "现货跟单交易",
  "spotMarginTrading": "现货杠杆交易",
  "spotTrading": "现货交易",
  "spotTradingReqCalculationQualification": "要判断我有资格获得 2 张还是 3 张抽奖券，现货交易量要求是如何计算的？",
  "spotTradingVolCopyTrdPro": "跟单交易 Pro 产生的现货交易量",
  "spotTradingVolume200Usdt": "现货交易量：200 USDT",
  "spotTradingVolume300Usdt": "现货交易量：300 USDT",
  "spotTradingVolumeUsdt": "现货交易量：100 USDT",
  "spotTradingVolumeZeroFees": "0 手续费现货交易对产生的交易量",
  "status": "状态",
  "step": "Step",
  "stop_limit": "止盈止损",
  "stop_limit_tips_2": "当前有止盈止损委托单，暂不支持开启杠杆交易。",
  "subBtnText": "订阅",
  "subscribeOrJoinLottery": "投入 MNT，参与申购；或投入 USDT，参与抽奖",
  "subscribeToBuyTokenWithCurrency": "投入 {currency}，申购 {token}",
  "subscribeTokenWithAvgBal": "日均持仓量至少达到 {minPledgeAmount} {currency}，即可申购 {token} 分配。",
  "subscriptionEligibilityConfirmation": "恭喜！您符合申购参与资格。",
  "subscriptionEligibilityInfo": "如果您已按建议追加买入/充值 {currency}，且未提币或卖币，则符合申购参与资格，无需再次买入/充值。您的最终日均持仓量将于 {time} 3:30 (UTC) 更新。",
  "subscriptionHoldingsError": "抱歉！您的日均持仓量未达到参与申购的最低资格要求，因此您不能参与申购。下次 Launchpad 请确保 {currency} 充值数额达到要求。",
  "subscriptionPeriodCalc": "如何计算申购期内的最终代币分配数量？",
  "subToastSuccess": "订阅成功",
  "success": "成功",
  "sure": "sure",
  "theTokenSaleHasAlreadyEnded": "代币发售已结束。",
  "times": "次",
  "timestamp": "时间",
  "title_404": "404 {'|'} Bybit 现货交易平台  ",
  "title_exchange": "{close} {'|'} {symbols} {'|'} Bybit 现货交易平台 ",
  "to": "至",
  "toastTheSymbolNotExist": "抱歉！您选择的交易对暂无法访问",
  "tokenLaunchpadUpdateNotice": "很抱歉，您当前持仓量不符合 {{TOKEN_NAME}} Launchpad 参与要求。点此了解详情 👉",
  "tokenSale": "首次代币发售",
  "tokenSaleEligibilityError": "您未在 {time1} – {time2} (UTC) 参与活动，因此不能获得代币分配。",
  "tokenSaleRecords": "代币发售记录",
  "tokenSaleSubscriptionError": "您已选择投入 USDT 参与抽奖，因此不能投入 MNT 参与申购。",
  "total": "累计",
  "totalSupply": "发行总量",
  "tradingPairs": "现货交易对",
  "tradingVolume": "交易量",
  "transactionRecords": "其中包括您所有的买入和卖出交易。 ",
  "transfer": "划转",
  "transferableBalanceNotEnough": "划转失败，可用余额不足。",
  "turnover": "成交额",
  "unifiedTradingAccount": "统一交易账户",
  "unsubBtnText": "退订",
  "unsubToastSuccess": "退订成功",
  "updateDailyAvgMntHoldings": "用户 2 月 23 日的 MNT 日均持仓量将于 2 月 24 日 3:00 (UTC) 后更新为 25 MNT。",
  "updateDailyHoldingsFeb23": "假设 MNT/USDT 收盘价为 1 USDT，用户 2 月 23 日的日均持仓量将于 2 月 24 日 3:00 (UTC) 后更新为 25 USDT。",
  "updateTradeVolumeFeb23": "用户 2 月 23 日的每日累计交易量将于 2 月 24 日 3:00 (UTC) 后更新为 600 USDT。",
  "updateUsdtHoldingsFeb23": "用户 2 月 23 日的 USDT 日均持仓量将于 2 月 24 日 3:00 (UTC) 后更新为 25 USDT。",
  "usdc_contract_account": "USDC 合约账户",
  "usdtHoldings": "USDT 持仓量",
  "usdtPairsTradingVolumeSum": "对于以 USDT 计价的交易对，交易量为所有已成交 USDT 订单的订单价值之和。 ",
  "viewDetails": "了解详情",
  "volume": "已成交量",
  "walletBalanceInUsdt": "钱包余额：100 USDT",
  "walletBalanceMnt100": "钱包余额：100 MNT",
  "walletBalanceMnt200": "钱包余额：200 MNT",
  "walletBalanceMnt300": "钱包余额：300 MNT",
  "walletBalanceUsdt200": "钱包余额：200 USDT",
  "walletBalanceUsdt300": "钱包余额：300 USDT",
  "whiteBook": "白皮书",
  "whoIsEligible": "哪些用户符合 Launchpad 参与资格？",
  "winningNumber": "中签号码："
}